const generatePdfForProjectFromHtml = async ({
  html,
  isLandscapeMode,
  locale,
  filename,
  shoppingListId, 
  emailId
}: {
  html: string;
  isLandscapeMode: boolean;
  locale: string;
  filename: string;
  shoppingListId: string;
  emailId: string;

}) => {
  const res = await fetch(`/${locale}/api/pdf-my-project-html/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ html, isLandscapeMode, filename, shoppingListId, emailId }),
  });

  if (!res.ok) {
    console.log(`Error when generating and uploading PDF: ${res.statusText}`);
  }
};

const generatePdfFromHtml = async ({
  html,
  isLandscapeMode,
  locale,
}: {
  html: string;
  isLandscapeMode: boolean;
  locale: string;
}): Promise<Blob> => {
  const res = await fetch(`/${locale}/api/pdf-my-html/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ html, isLandscapeMode }),
  });

  if (!res.ok) {
    throw new Error(`Failed to generate PDF: ${res.statusText}`);
  }

  return await res.blob();
};

const uploadProjectPdf = async ({
  file,
  filename,
  email,
  shoppingListId,
  locale,
}: {
  file: Blob;
  filename: string;
  email: string;
  shoppingListId: string;
  locale: string;
}) => {
  const formData = new FormData();
  formData.append('file', file, filename);
  formData.append('metadata', JSON.stringify({ emailId: email, shoppingListId }));

  const res = await fetch(`/${locale}/api/upload-project-pdf/`, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    throw new Error('Failed to upload PDF');
  }
};

const downloadProjectPdf = async ( filename:string, locale:string ) => {

  const res = await fetch(`/${locale}/api/download-project-pdf/`, {
    method: 'POST',
    body: JSON.stringify({ filename }),
  });

  if (!res.ok) 
    return null;
  else
    return await res.blob();
};

export { generatePdfFromHtml, generatePdfForProjectFromHtml, uploadProjectPdf, downloadProjectPdf };
